
import { CacheLookupPolicy } from "@azure/msal-browser";
import axios from "axios";
import { accessTokenRequestScope,msalInstance } from "../authConfig";


const BASE_SERVER_URL=process.env.REACT_APP_BASE_SERVER_URL

//change localhost to your server IP
//axios.defaults.baseURL = 'http://localhost:8080';
//axios.defaults.baseURL = '/ajax/ops';
axios.defaults.baseURL =BASE_SERVER_URL 


//axios.defaults.headers.common['ExtraUserInfo'] = 'AUTH_TOKEN';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';



// axios.interceptors.response.use((response) => {
//     return response;
// }, function (error) {
//     // Do something with response error
//     // if (error.response.status === 401) {
//     //     console.log('unauthorized, logging out ...');
//     //     auth.logout();
//     //     router.replace('/auth/login');
//     // }
//     //alert(33232)
//     console.error("111111111111111111111111111111111")
//     console.error(error.response.data)
//     return Promise.reject(error.response.data);
// });

axios.interceptors.request.use(async (config) => {
    const instance =msalInstance;

    const accounts = await instance.getActiveAccount();

    console.log("axios")
    console.log(accounts)
    console.log(accessTokenRequestScope);
    if(accounts)
    {
        const accessTokenRequest = {
            ...accessTokenRequestScope,
            account: accounts
        };
    
        try{
            console.log(accessTokenRequest)
            const token = await instance.acquireTokenSilent(accessTokenRequest);
            console.log(token)
            config.headers["Authorization"] = "Bearer " + token.accessToken;
            console.log("finish at retrieval"); 
        }catch (ex)
        {
            console.log("retry if failure");
            console.log(ex);
            const token = await instance.acquireTokenSilent(accessTokenRequest);
            config.headers["Authorization"] = "Bearer " +token.accessToken;
            console.log("finish at retrieval");
        }
        
        return Promise.resolve(config);
    }
    else
    {
        return Promise.reject("No token");
    }
   
}, (error) => { 
    return Promise.reject(error);
});
const webApi = {

    httpGet : async (url, params={})=>
    {
        console.log("PPPPPPPPPPPPPPPPPPPPPPPP")
        console.log(params)
            let response = await axios.get(url, {params:{...params}})
            return response;
    },

    httpPost : async (url, body)=>
    {
        let response = await axios.post(url, body)
        return response;
    },

    httpPut : async (url, body, header={})=>
    {
        console.log("Put-url::"+url)
     
        let response = await axios.put(url, body)
        return response;
    },

     httpDelete : async (url, body={})=>
    {
        let response = await axios.delete(url, body)
        return response;
    },

    httpPostMultiPart : async (url, formData)=>
    {
        let response = await axios.post(url, formData, {headers: {"Content-Type": "multipart/form-data"}})
        return response;
    },
}

export default webApi;

